import {createApi} from "@reduxjs/toolkit/query/react"
import baseQuery from "../../utils/apiIIKOConfig"
import {IBasicResponse} from "../../types/api"
import {IShipping} from "./ShippingTypes"
import {IShippingCreateParams, IShippingUpdateParams} from "./ShippingApiTypes"

export const shippingApi = createApi({
    reducerPath: "shippingApi",
    baseQuery,
    tagTypes: ["shipping"],
    endpoints: build => ({
        getShipping: build.query<IBasicResponse<IShipping[]>, void>({
            query: () => `v1/shipping`,
            providesTags: ["shipping"]
        }),
        createShipping: build.mutation<IBasicResponse<void>, IShippingCreateParams>({
            query: ({extra_price_per_km, fixed_price, distance_limit}) => ({
                method: "POST",
                url: `v1/shipping`,
                body: {
                    extra_price_per_km,
                    fixed_price,
                    distance_limit
                }
            }),
            invalidatesTags: ["shipping"]
        }),
        updateShippingById: build.mutation<IBasicResponse<void>, IShippingUpdateParams>({
            query: ({extra_price_per_km, fixed_price, distance_limit, id}) => ({
                method: "PUT",
                url: `v1/shipping/${id}`,
                body: {
                    extra_price_per_km,
                    fixed_price,
                    distance_limit
                }
            }),
            invalidatesTags: ["shipping"]
        })
    })
})

export const {useGetShippingQuery, useCreateShippingMutation, useUpdateShippingByIdMutation} = shippingApi
